import { action, makeObservable, observable } from 'mobx';

import { Model } from './Model';

export interface ITinetsConfigModels {
    levels?: {
        level: number;
        tinetsRequired: number;
    }[];

    tasks?: {
        id: number;
        title: string;
        description: string;
        tinetsDelta: number;
    }[]
}

export class TinetsConfigModels extends Model implements ITinetsConfigModels {
    levels: ITinetsConfigModels['levels'] = [];
    tasks: ITinetsConfigModels['tasks'] = [];

    constructor(payload: ITinetsConfigModels = {}) {
        super();

        makeObservable(this, {
            levels: observable,
            tasks: observable,
            update: action,
        });

        this.update(payload);
    }
}
